import {  MESSAGE_SET_UNREAD_DATA } from '../action-types';

const initState = {
    unreadData: null  // 存储完整的未读消息数据
};

export default function message(state = initState, action) {
    switch (action.type) {
        case MESSAGE_SET_UNREAD_DATA:
            const newState = {
                ...state,
                unreadData: action.data,
            };
            return newState;
        default:
            return state;
    }
} 